import React, { memo, useCallback } from "react";
import { Button } from "@chakra-ui/react";
import colors from "app/colors";
import { MessageFragment, MessageThreadFragment } from "gql/graphql";
import { MessageSubType } from "modules/utils/Constants";
import { useOverlay } from "modules/providers/overlay-provider";
import { DRAWER_TYPE } from "modules/providers/overlay-provider/overlay-provider";

interface IProps {
  messageThread: MessageThreadFragment;
  message: MessageFragment;
}

const ViewThreadDetailsButton = ({ messageThread, message }: IProps) => {
  const { openDrawer } = useOverlay();

  const onClick = useCallback(() => {
    openDrawer({
      type: DRAWER_TYPE.MESSAGE_THREAD_PROFILE,
      id: messageThread.id,
    });
  }, [messageThread.id, openDrawer]);

  if (message.subType !== MessageSubType.OUT_OF_OFFICE) {
    return null;
  }

  return (
    <Button
      variant="link"
      w="fit-content"
      fontSize={12}
      color={colors.blue}
      fontWeight={700}
      onClick={onClick}
    >
      {"> View Details"}
    </Button>
  );
};

export default memo(ViewThreadDetailsButton);
